<template>
	<div id="app">
		<div class="content">
			<img alt="The Weight Gurus logo" class="logo" src="./assets/logo.png" />
			<form v-on:submit.prevent="resetPassword()" class="inputs">
				<div class="input" v-bind:class="{ disabled: !validToken }">
					<label for="newPassword">New Password</label>
					<input id="newPassword" type="password" v-model="newPassword" v-bind:disabled="!validToken" required />
				</div>
				<div class="input" v-bind:class="{ disabled: !validToken ||!passwordValid }">
					<label for="confirmPassword">Confirm Password</label>
					<input id="confirmPassword" type="password" v-model="confirmPassword" v-bind:disabled="!validToken ||!passwordValid" required />
				</div>
				<div class="reset-button">
					<button v-bind:disabled="!validToken || showOverlay || !passwordValid || !passwordMatch" type="submit">Reset Password</button>
				</div>
			</form>
		</div>
		<div v-if="showOverlay" class="overlay">
			<div class="overlay-content">
				<h1 v-text="overlay.header"></h1>
				<div class="overlay-text" v-html="overlay.body">
				</div>
				<button class="overlay-button" type="submit" v-on:click="closeWindow()">Exit</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'app',
	data () {
		return {
			api: 'https://api.weightgurus.com/v2/user/passwordReset',
			confirmPassword: '',
			newPassword: '',
			showOverlay: false,
			urlParams: {},
			validToken: true,
			overlay: {
				header: '',
				body: ''
			}
		}
	},
	created: function () {
		this.urlParams = this.getUrlParams();

		if (this.urlParams.v === '3') {
			this.api = 'https://api.weightgurus.com/v3/account/password-reset'
		}

		if (!this.urlParams.t) {
			this.setOverlayMessage('token');
		} else if (!this.urlParams.i) {
			this.setOverlayMessage('id');
		} else {
			this.$http.post(`${this.api}/check`, {
					token: this.urlParams.t,
					userId: this.urlParams.i,
					accountId: this.urlParams.i
				}).then((res) => {
				}, (err) => {
					if (err.status === 401) {
						this.setOverlayMessage('token');
					} else {
						this.setOverlayMessage('generic');
					}
				});
		}
	},
	methods: {
		closeWindow: function() {
			window.close();
		},
		getUrlParams: function() {
			let urlParams = {i:'', t:'', v:''};
			try {
				const paramString = window.location.href.split('?')[1];
			paramString.split('&').forEach(function(paramStringSegment){
				const paramArray = paramStringSegment.split('=');
				const key = paramArray.shift();
				const value = paramArray.join('=');
				urlParams[key] = value;
			});

			return urlParams;

			} catch(e) {
				this.setOverlayMessage('generic');
			}
		},
		resetPassword: function() {
			const data = {
				userId: this.urlParams.i,
				accountId: this.urlParams.i,
				token: this.urlParams.t,
				password: this.newPassword
			};
			this.$http.post(`${this.api}/confirm`, data).then((res) => {
				if (res.status === 204) {
					this.setOverlayMessage('success');
				}
			}, (err) => {
				if (err.status === 401) {
					this.setOverlayMessage('token');
				} else {
					this.setOverlayMessage('generic');
				}
			});
		},
		setOverlayMessage: function(type) {
			this.showOverlay = false;
			this.overlay.header = 'Error';

			switch (type) {
				case 'generic':
					this.overlay.body =
						`Please try requesting a password reset from the app again or contact customer support.
						<ul class="contact">
							<li>Call <a alt="Call customer support" href="tel:+01-866-991-8494">866.991.8494</a> or</li>
							<li>email <a alt="Email customer support" href="mailto:info@greatergoods.com">info@greatergoods.com</a></li>
						</ul>`;
					this.showOverlay = true;
					break;
				case 'id':
					this.overlay.body = 'User ID is invalid.<p>Please try requesting a password reset from the app again.</p>';
					this.showOverlay = true;
					break;
				case 'token':
					this.overlay.body = 'Reset password token is invalid or has expired.<p>Please try requesting a password reset from the app again.</p>';
					this.showOverlay = true;
					this.validToken = false;
					break;
				case 'success':
					this.overlay.header = 'Password Reset!';
					this.overlay.body = 'You can now log in with your new password on the Weight Gurus App.';
					this.showOverlay = true;
					break;
				default:
					this.overlay.header = '';
					this.overlay.body = '';
					this.showOverlay = false;
			}
		}
	},
	computed: {
		passwordValid: function() {
			return this.newPassword.length >= 6;
		},
		passwordMatch: function() {
			return this.newPassword === this.confirmPassword;
		}
	}
};
</script>

<style>
	html {
		background: linear-gradient(0deg, #5D89B4, #82B8EB);
		min-height: 100vh;
		width: 100vw;
	}

	body {
		align-items: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		text-align: center;
	}

	* {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
	}

	a {
		color: #5D89B4;
	}

	a:hover {
		color: #82B8EB;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	button {
		background-color: #FFF;
		border-radius: 3px;
		border: none;
		cursor: pointer;
		font-size: 1rem;
		height: 40px;
		outline: none;
		width: 100%;
	}

	button:active, button:focus {
		background-color: #DDD;
	}

	button:disabled, .disabled {
		opacity: .5;
	}

	.content {
		margin-top: 10vh;
	}

	input {
		background-color: transparent;
		border: none;
		color: #F4F4F4;
		font-size: 1em;
		height: 1.75rem;
		outline: none;
		padding-left: 8em;
		transition: border-bottom 0.2s;
		width: 100%;
	}

	.input {
		align-items: center;
		background-color: rgba(0, 0, 0, 0.2);
		display: flex;
		justify-content: flex-start;
		margin: 3px auto 0;
		position: relative;
		width: 100%;
	}

	.inputs {
		margin-top: 5vh;
		min-width: 80%;
	}

	label {
		color: #EEE;
		cursor: text;
		font-size: .8em;
		left: 1em;
		position: absolute;
	}

	.logo {
		margin-top: 10vh;
		max-width: 450px;
		width: 65%;
	}

	.overlay {
		align-items: center;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		height: 100vh;
		justify-content: center;
		left: 0;
		position: absolute;
		top: 0;
		width: 100vw;
	}

	.overlay-content {
		background-color: #FFF;
		border-radius: 5px;
		box-sizing: border-box;
		margin-top: 25vh;
		margin: auto;
		max-width: 500px;
		position: relative;
		transition: top 1s;
		width: 90%;
	}

	.overlay-content .overlay-text{
		padding: 0 10% 2.5%;
	}

	.overlay-content .overlay-text p {
		font-size: .8em;
	}

	.overlay-content .overlay-text .contact {
		font-size: .8em;
		line-height: 2em;
		list-style-type: none;
		padding: 0;
		text-decoration: none;
	}

	.reset-button {
		margin-top: 2rem;
		min-width: 60%;
	}


	@media (min-width: 700px) {
		.logo {
			width: 75%;
		}
	}

	@media (min-width: 1000px) {
		.logo {
			width: 90%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue